module.exports = __webpack_public_path__ + "static/media/receipt.8559ba37.svg";